import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/toxicologia/evaluación-de-riesgos-de-las-nitrosaminas")({
  beforeLoad: () => { throw redirect({ href: "/es/servicios/toxicologia-regulatoria/evaluaci\u00f3n-de-riesgos-de-las-nitrosaminas", statusCode: 301 }); },
});
